export const getSearchBoxState = (state) => state.searchBoxState;
export const getFirstDepartureDate = (state) => state.searchBoxState?.searchSegments?.[0]?.departureDate;
export const getLastArrivalDate = (state) => state.searchBoxState?.type === "ROUNDTRIP"
    ? state.searchBoxState?.searchSegments?.[state.searchBoxState?.searchSegments.length - 1]?.returnDate
    : state.searchBoxState?.type === "MULTISTOP"
        ? state.searchBoxState?.searchSegments?.[state.searchBoxState?.searchSegments.length - 1]?.departureDate
        : undefined;
export const getSearchType = (state) => state.searchBoxState?.type;
